"use client"

import React, {useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import styles from '../index.module.css'
import {SimpleGrid, UnstyledButton} from "@mantine/core";
import LinkItem, {CountryPartnerItem} from "@/app/(index)/related-links/link";
import InterPage from "@/app/(index)/global-network/inter";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

export default function Page() {
    const { fontSize, lang } = useGlobalStateStore();
    const [tab, setTab] = useState<number>(1);
    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>

                {
                    mediaQueryLessSM && (
                        <Bread name_c="關於科政中心 - 國際合作" name_e="About STPI - Global Network"/>
                    )
                }
                <div
                    className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] text-[#5b5b5b] text-[35px] font-bold">
                        { lang == "tw" ? "國際合作" : "Global Network" }
                    </div>
                    <div className={cx(!mediaQueryLessSM && 'pt-10')}>
                        <div className="flex justify-end gap-1 border-b border-[#79b7b4]">
                            <UnstyledButton onClick={() => setTab(1)}>
                                <div
                                    className={cx(tab === 1 ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                        "text-white py-[15px] px-[25px] font-bold", loadCurrentFontSize(14, 18, 20))}>
                                    { lang == "tw" ? "國際合約" : "Partners" }
                                </div>
                            </UnstyledButton>
                            <UnstyledButton onClick={() => setTab(2)}>
                                <div
                                    className={cx(tab === 2 ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                        "text-white py-[15px] px-[25px] font-bold", loadCurrentFontSize(14, 18, 20))}>
                                    { lang == "tw" ? "國際活動" : "International Events" }
                                </div>
                            </UnstyledButton>
                        </div>
                    </div>


                    {
                        (tab == 1 && lang == "tw") && (
                            <SimpleGrid cols={mediaQueryLessSM ? 2 : 1}>
                                <CountryPartnerItem country="荷蘭" flag="Netherlands" name="烏特勒支市政府經濟委員會" subName="Economic Board Utrecht (EBU)"/>
                                <CountryPartnerItem country="韓國" flag="Korea" name="韓國科學技術資訊院" subName="Korea Institute of Science and Technology Information (KISTI)"/>
                                <CountryPartnerItem country="韓國" flag="Korea" name="韓國科技政策研究院" subName="Science and Technology Policy Institute (STEPI)"/>
                                <CountryPartnerItem country="韓國" flag="Korea" name="韓國科技評價與計畫院" subName="Korea Institute of Science and Technology Evaluation and Planning (KISTEP)"/>
                                <CountryPartnerItem country="日本" flag="JP" name="科學技術振興機構" subName="Japan Science and Technology Agency (JST)"/>
                                <CountryPartnerItem country="美國" flag="USA" name="科睿唯安" subName="Clarivate Analytics, 原湯森路透智慧財產權與科技事業部"/>
                                <CountryPartnerItem country="美國" flag="USA" name="史丹佛大學" subName="Stanford University"/>
                                <CountryPartnerItem country="亞洲" flag="GLOBAL" name="亞太經濟合作" subName="APEC"/>

                                <CountryPartnerItem country="德國" flag="GERMANY" name="杜賓根大學 " subName="University of Tübingen"/>
                                <CountryPartnerItem country="美國" flag="USA" name="華盛頓大學" subName="University of Washington"/>
                                <CountryPartnerItem country="法國" flag="FRANCE" name="法國國立東方語言與文化學院" subName="The Institut national des langues et civilisations orientales"/>
                            </SimpleGrid>
                        )
                    }

                    {
                        (tab == 1 && lang == "en") && (
                            <SimpleGrid cols={2}>
                                <CountryPartnerItem country="Korea" flag="Korea" name="Korea Institute of Science and Technology Information, KISTI"/>
                                <CountryPartnerItem country="Korea" flag="Korea" name="Science and Technology Policy Institute, STEPI"/>
                                <CountryPartnerItem country="Korea" flag="Korea" name="Korea Institute of Science and Technology Evaluation and Planning, KISTEP"/>
                                <CountryPartnerItem country="Japan" flag="JP" name="Japan Science and Technology Agency, JST"/>
                                <CountryPartnerItem country="USA" flag="USA" name="Clarivate Analytics"/>
                                <CountryPartnerItem country="USA" flag="USA" name="Stanford University"/>
                                <CountryPartnerItem country="Asia" flag="GLOBAL" name="APEC"/>

                                <CountryPartnerItem country="Germany" flag="GERMANY" name="University of Tübingen"/>
                                <CountryPartnerItem country="USA" flag="USA" name="University of Washington"/>
                                <CountryPartnerItem country="France" flag="FRANCE" name="The Institut national des langues et civilisations orientales"/>
                            </SimpleGrid>
                        )
                    }

                    {
                        tab == 2 && (
                            <div className={cx(mediaQueryLessSM ? '' : 'pt-10')}>
                                <InterPage/>
                            </div>
                        )
                    }

                </div>
            </div>
            <Footer/>
        </div>
    );
}
